import {useMutation, useQueryClient} from '@tanstack/react-query';
import {UseFormReturn} from 'react-hook-form';
import {apiClient} from '@common/http/query-client';
import {toast} from '@common/ui/toast/toast';
import {useTrans} from '@common/i18n/use-trans';
import {onFormQueryError} from '@common/errors/on-form-query-error';
import {message} from '@common/i18n/message';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import { ProductTemplate } from '@app_modules/product-templates/product-template';
import { DatatableDataQueryKey } from '@common/datatable/requests/paginated-resources';

export interface UWFileData {
  files: any;
}

interface Response extends BackendResponse {
  uwdata: UWFileData;
}

export interface UwFilePayload {
  report_id: number|string;
  files: Array<File>;
}

export function useAppendFileItem(report_id: number|string, form: UseFormReturn<UwFilePayload>) {
  return useMutation({
    mutationFn: (payload: UwFilePayload) => apendFiles(report_id, payload),
    onSuccess: async () => {
      //toast(trans(message('UW processed')));
    },
    onError: err => onFormQueryError(err, form),
  });
}

async function apendFiles(report_id: number|string, payload: UwFilePayload) {
    return apiClient.post<Response>(`${report_id}/demo-append-source-uw`, UwFilePayloadToFormData(payload), {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).then(r => r.data);
}


export function UwFilePayloadToFormData(
  payload: Partial<UwFilePayload>,
) {
  const formData = new FormData();
  
  if (payload.files) {
    payload.files.forEach((file) => {
      formData.append("files[]", file);
    });
  }
  
  return formData;
}
